/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export class UpdateUserModel {
    id: string = undefined;
    email: string = undefined;
    groupIds: string[] = [];
    roles: string[] = [];
    combineReports: boolean = undefined;
    receiveAutomatedCarrierStatusReport: boolean = undefined;
    millCodes: string[] = [];
    userName: string = undefined;
    firstName: string = undefined;
    lastName: string = undefined;
    auth0UserId: string = undefined;
}
